import {useFaxQuery} from "@/components/fax/queries.generated";
import {useCallback} from "react";
import {createInitialData} from "@/components/fax/settings/initialData";
import {UpdateFaxMutationVariables} from "../mutations.generated";
import {DomainOutgoingCallBarrings, useDomainNameQuery, useDomainOutgoingCallBarringsQuery} from "@/hooks";

export type DataSource = {
    loading: boolean;
    refetch: () => Promise<UpdateFaxMutationVariables>;

    fax: UpdateFaxMutationVariables;
    domainName: string;
    domainOutgoingCallBarrings: DomainOutgoingCallBarrings;
};

export const useDataSource = (faxId: number, domainId: number): DataSource => {
    const faxQuery = useFaxQuery({
        variables: {id: faxId},
        fetchPolicy: "no-cache",
    });
    const {domainName, loading: domainNameLoading} = useDomainNameQuery(domainId);
    const {domainOutgoingCallBarrings, loading: domainOutgoingCallBarringsLoading} =
        useDomainOutgoingCallBarringsQuery(domainId);

    const refetch = useCallback(async () => createInitialData((await faxQuery.refetch()).data), [faxQuery]);

    if (faxQuery.loading || domainNameLoading || domainOutgoingCallBarringsLoading) {
        return {
            loading: true,
            refetch,
            fax: undefined,
            domainName,
            domainOutgoingCallBarrings: {
                admin: [],
                operator: [],
            },
        };
    }

    return {
        loading: false,
        refetch,
        fax: createInitialData(faxQuery.data),
        domainName,
        domainOutgoingCallBarrings,
    };
};
